import React from 'react';
import Loadable from 'react-loadable';

const Loading = ({ error, timedOut, pastDelay }) => {
  if (error || timedOut) {
    return (
      <p>
        This question failed to load. We&#39;ve been notified and will fix the
        issue shortly. Please refresh the page and try again.
      </p>
    );
  } else if (pastDelay) {
    return (
      <div
        className="pull-right rounded bc-light_gray"
        style={{ height: '1rem' }}
      />
    );
  } else {
    return (
      <div
        className="pull-right rounded bc-light_gray"
        style={{ height: '1rem' }}
      />
    );
  }
};

export default Loadable({
  loader: () =>
    import(/* webpackChunkName: "SurveyResultsFilter" */ '../../components/results/FilterWidget/SurveyResultsFilter'),
  loading: Loading,
});
